import React from 'react';
import { Contact } from '../components/Contact';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-description">
            Have questions? Want to discuss a project? We're here to help!
          </p>
        </div>
      </div>
      <Contact />
    </div>
  );
};

export default ContactPage;